import { render, staticRenderFns } from "./ReportCharts.vue?vue&type=template&id=723a8b74"
import script from "./ReportCharts.vue?vue&type=script&lang=js"
export * from "./ReportCharts.vue?vue&type=script&lang=js"
import style0 from "./ReportCharts.vue?vue&type=style&index=0&id=723a8b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
